import { render, staticRenderFns } from "./level-selector.vue?vue&type=template&id=7b454b1c&scoped=true&"
import script from "./level-selector.vue?vue&type=script&lang=js&"
export * from "./level-selector.vue?vue&type=script&lang=js&"
import style0 from "./level-selector.vue?vue&type=style&index=0&id=7b454b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b454b1c",
  null
  
)

export default component.exports